export function isEditing() {
    // @ts-expect-error custom window variable
    return window && window.wp && window.wp.editor;
}
